import React from 'react';
import PropTypes from 'prop-types';
import { compact } from 'lodash-es';
import { getLeaseDealsValueRating } from 'site-modules/lease-deals/utils/get-lease-deals-value-rating';
import { RatingIcon } from './rating-icon/rating-icon';
import { EffectivePaymentInsight } from './effective-payment-insight/effective-payment-insight';
import { LifetimeCostInsight } from './lifetime-cost-insight/lifetime-cost-insight';
import { LeaseScoreInsight } from './lease-score-insight/lease-score-insight';

export function KeyInsightsList({
  effectivePayment,
  effectivePaymentMedian = undefined,
  term,
  bodyType = undefined,
  lifetimeCost = undefined,
  dueAtSigning,
  monthlyPayment,
  msrp,
  effectivePaymentRatio,
  showEffectivePaymentText = false,
  isShop4931ZeroDownRoute = false,
}) {
  const { rating } = getLeaseDealsValueRating(effectivePaymentRatio);

  const insights = compact([
    !!effectivePaymentMedian && (
      <EffectivePaymentInsight
        effectivePayment={effectivePayment}
        effectivePaymentMedian={effectivePaymentMedian}
        bodyType={bodyType}
        showEffectivePaymentText={showEffectivePaymentText}
      />
    ),
    !!lifetimeCost && (
      <LifetimeCostInsight
        lifetimeCost={lifetimeCost}
        dueAtSigning={dueAtSigning}
        monthlyPayment={monthlyPayment}
        term={term}
        effectivePayment={effectivePayment}
        isShop4931ZeroDownRoute={isShop4931ZeroDownRoute}
      />
    ),
    !!lifetimeCost && (
      <LeaseScoreInsight
        lifetimeCost={lifetimeCost}
        msrp={msrp}
        term={term}
        effectivePaymentRatio={effectivePaymentRatio}
      />
    ),
  ]);

  return (
    <ul className="key-insights-list list-unstyled mb-0">
      {insights.map((insight, index) => (
        // eslint-disable-next-line react/no-array-index-key
        <li key={index} className="mt-1 d-flex">
          <RatingIcon rating={rating} />
          <div className="ms-0_5">{insight}</div>
        </li>
      ))}
    </ul>
  );
}

KeyInsightsList.propTypes = {
  effectivePayment: PropTypes.number.isRequired,
  effectivePaymentMedian: PropTypes.number,
  term: PropTypes.number.isRequired,
  bodyType: PropTypes.string,
  lifetimeCost: PropTypes.number,
  dueAtSigning: PropTypes.number.isRequired,
  monthlyPayment: PropTypes.number.isRequired,
  msrp: PropTypes.number.isRequired,
  effectivePaymentRatio: PropTypes.number.isRequired,
  showEffectivePaymentText: PropTypes.bool,
  isShop4931ZeroDownRoute: PropTypes.bool,
};
